import { render, staticRenderFns } from "./OrganisationThemeingLight.vue?vue&type=template&id=610d74c4&"
import script from "./OrganisationThemeingLight.vue?vue&type=script&lang=js&"
export * from "./OrganisationThemeingLight.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationThemeingLight.vue?vue&type=style&index=0&id=610d74c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports